/**
 * @generated SignedSource<<f8006894cfaa172e9a1e19805160fd2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedFeaturedDeal_l1Module$data = {
  readonly firstTile: {
    readonly mainImage: string | null;
  } | null;
  readonly " $fragmentType": "SbSharedFeaturedDeal_l1Module";
};
export type SbSharedFeaturedDeal_l1Module$key = {
  readonly " $data"?: SbSharedFeaturedDeal_l1Module$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedFeaturedDeal_l1Module">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedFeaturedDeal_l1Module",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "L1ModuleItemTile",
      "kind": "LinkedField",
      "name": "firstTile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mainImage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "L1Module",
  "abstractKey": null
};

(node as any).hash = "13e165aee2ee8074e3bb3dc64efa003e";

export default node;
